import React from "react";
import Image from "next/image";
import { useSystemStore } from "./systemStore";

export const BackButton: React.FC<{
  size?: number;
  backTo?: any;
  customClassName?: any;
  color?: string;
}> = ({ size = 9, backTo = "", customClassName = "", color = "#19093A" }) => {
  const theme = useSystemStore((state) => state.theme);

  return (
    <a onClick={backTo} className={`cursor-pointer ${customClassName}`}>
      <Image 
        src={"/images/back-button.svg"}
        alt="back"
        width={size}
        height={size}
        className={theme === "dark" ? "invert brightness-0" : ""}
      />
    </a>
  );
};
